// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"FullWidth_fullWidth__3nzb9","labelGroup":"FullWidth_labelGroup__tBBUD"};